import useSafeState from '../../utils/safe-state';
import React, { ReactElement } from 'react';

interface Interface {
    icon: ReactElement;
    text: ReactElement;
}

const ButtonWithIconSuff = (props: Interface) => {

    const createIcon = (): React.ReactNode => {
        return React.cloneElement(props.icon, {});
    };

    const createText = (): React.ReactNode => {
        return React.cloneElement(props.text, {});
    };

    return (
        <>
            <span>{createText()}</span>
            {createIcon()}
        </>
    );
};

export default ButtonWithIconSuff;
